import { render, staticRenderFns } from "./DynamicAddressField.vue?vue&type=template&id=22de00a2&scoped=true&"
import script from "./DynamicAddressField.vue?vue&type=script&lang=js&"
export * from "./DynamicAddressField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicAddressField.vue?vue&type=style&index=0&id=22de00a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22de00a2",
  null
  
)

export default component.exports